const appUpdate = {
  namespaced: true,
  state: {
    showUpdateModal: false, // 是否显示更新详情弹窗
    showUpdateTip: false, // 是否显示更新提示
    downloaded: false, // 是否下载完成
    downloadProgress: 0, // 下载进度
    updated: false, // 是否更新完成
    updateError: false, // 是否更新失败
    // 从更新提示打开更新日志
    openUpdateLogByUpdatedTips: false,
  },
  getters: {
    showUpdateModal: (state) => state.showUpdateModal,
    showUpdateTip: (state) => state.showUpdateTip,
    downloaded: (state) => state.downloaded,
    downloadProgress: (state) => state.downloadProgress,
    updated: (state) => state.updated,
    updateError: (state) => state.updateError,
    openUpdateLogByUpdatedTips: (state) => state.openUpdateLogByUpdatedTips,
  },
  mutations: {
    setShowUpdateModal(state, showUpdateModal) {
      state.showUpdateModal = showUpdateModal
    },
    setShowUpdateTip(state, showUpdateTip) {
      state.showUpdateTip = showUpdateTip
    },
    setDownloaded(state, downloaded) {
      state.downloaded = downloaded
    },
    setDownloadProgress(state, downloadProgress) {
      state.downloadProgress = downloadProgress
    },
    setUpdated(state, updated) {
      state.updated = updated
    },
    setUpdateError(state, updateError) {
      state.updateError = updateError
    },
    setOpenUpdateLogByUpdatedTips(state, openUpdateLogByUpdatedTips) {
      state.openUpdateLogByUpdatedTips = openUpdateLogByUpdatedTips
    },
  },
  actions: {
    setShowUpdateModal({ commit }, showUpdateModal) {
      commit('setShowUpdateModal', showUpdateModal)
    },
    setShowUpdateTip({ commit }, showUpdateTip) {
      commit('setShowUpdateTip', showUpdateTip)
      if (!showUpdateTip && process.env.IS_ELECTRON) {
        commit('setUpdated', false)
        window.ipcRenderer.send('cancel-updated-startup-params')
      }
    },
    setDownloaded({ commit, state }, downloaded) {
      commit('setDownloaded', downloaded)
      commit('setShowUpdateTip', downloaded)
    },
    setDownloadProgress({ commit }, downloadProgress) {
      commit('setDownloadProgress', downloadProgress)
    },
    setUpdated({ commit }, updated) {
      commit('setUpdated', updated)
    },
    setUpdateError({ commit }, updateError) {
      commit('setUpdateError', updateError)
    },
    setOpenUpdateLogByUpdatedTips({ commit }, openUpdateLogByUpdatedTips) {
      commit('setOpenUpdateLogByUpdatedTips', openUpdateLogByUpdatedTips)
    },
  },
}

export default appUpdate
